// src/pages/orders/AfricanOrderHistory.jsx
import React from 'react';
import OrderHistory from '../Waiters_OrderHistory';

const AfricanOrderHistory = () => {
  return <OrderHistory locationKey="african" />;
};

export default AfricanOrderHistory;